// ponytail: Windows Chrome/Edge don't ship the 🇲🇦 regional-indicator glyph pair
// (Microsoft has never shipped flag emoji), so it renders as literal "MA" text —
// a real regression for a Morocco-focused product. An inline SVG renders identically
// everywhere instead of depending on OS emoji-font support.
export default function MoroccoFlag({ className = "w-4 h-3" }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 30 20"
      className={`${className} inline-block flex-shrink-0 rounded-[1px]`}
      role="img"
      aria-label="Maroc"
    >
      <rect width="30" height="20" fill="#C1272D" />
      <path
        d="M15,4 L18.528,14.854 L9.294,8.146 L20.706,8.146 L11.472,14.854 Z"
        fill="none"
        stroke="#006233"
        strokeWidth="0.7"
        strokeLinejoin="round"
      />
    </svg>
  );
}
